const areaCarrousel = {
  'Area Carrousel Title': 'Ofertas de Empleo',
}

export default areaCarrousel
